<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    availableUserCredit: {
      type: Number,
      default: null,
    },
    userWinnings: {
      type: Number,
      default: null,
    },
    loyaltyCredits: {
      type: Number,
      default: null,
    },
  },
})
</script>

<template>
  <div class="flex w-full flex-col">
    <div class="w-full border-b pb-4 text-center text-xl font-bold">
      Balance Breakdown
    </div>
    <div v-if="loyaltyCredits !== null" class="flex justify-between py-2">
      <div>Loyalty Credit</div>
      <div class="font-bold">
        {{
          $n(loyaltyCredits, 'currency', {
            minimumFractionDigits: 2,
          })
        }}
      </div>
    </div>
    <div v-if="availableUserCredit !== null" class="flex justify-between pb-2">
      <div>Instant Prize Credit</div>
      <div class="font-bold">
        {{
          $n(availableUserCredit, 'currency', {
            minimumFractionDigits: 2,
          })
        }}
      </div>
    </div>
    <div v-if="userWinnings !== null" class="flex justify-between pb-2">
      <div>Winnings</div>
      <div class="font-bold">
        {{
          $n(userWinnings, 'currency', {
            minimumFractionDigits: 2,
          })
        }}
      </div>
    </div>
    <hr />
  </div>
</template>
